import React from "react";
import { SELLERS } from "../../consts/tables";
import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import SellerInfo from "./SellerInfo";
import SellerCompanyInfo from "./SellerCompanyInfo";

export default class CRUDSeller extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.fetch(this.props.params.id);
  }

  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: {},
      });
      return;
    }

    getData({
      tableCode: SELLERS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        this.setState({
          data: res.data[0],
          original: { ...res.data[0] },
          error: null,
        });
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      this.state.data.FIRST_NAME === undefined ||
      this.state.data.FIRST_NAME === "" ||
      this.state.data.LAST_NAME === undefined ||
      this.state.data.LAST_NAME === ""
    ) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      this.setState({ errorTabs: [] });
    }

    if (this.state.isBusy || this.state.viewMode === true) return;

    this.setState({ viewMode: true }, () => this.saveData());
  }

  handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value,
      }),
    });
  }

  handleChangeDropdown(query, queryType, x, key) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: query[key],
      }),
    });
  }

  saveData() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    Object.keys(this.state.data).forEach((k) => {
      if (!this.state.data[k] || k === "undefined") {
        const newData = { ...this.state.data };
        delete newData[k];
        this.setState({ data: newData });
      }
    });

    return manageData({ tableCode: SELLERS, data: [this.state.data] }).then(
      (res) => {
        if (res && res.success) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/seller/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );

          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <CRUD
        tabsData={[
          {
            name: "SELLER",
            renderedComponent: (
              <SellerInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
              />
            ),
          },
          {
            name: "SELLER COMPANY",
            renderedComponent: (
              <SellerCompanyInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
              />
            ),
          },
        ]}
        backLink={`${arc.path.base}sellers`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        type="seller"
        backName="SELLERS"
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
      />
    );
  }
}
